window.addEventListener('DOMContentLoaded', () => {
    const searchInputs = document.querySelectorAll('.search__input');
    
    searchInputs.forEach(searchInput => {
        searchInput.addEventListener('input', function() {
          if (searchInput.value !== '') {
            localStorage.setItem('searchTerm', searchInput.value);
          }
        });
    });

    if(document.querySelector('.heading-no-result')) {
        window.location.href = 'https://priints.com/collections/all-prints?no-result';
    }

    if(location.href == 'https://priints.com/collections/all-prints?no-result') {
        document.querySelector('.collection-hero__title').textContent = localStorage.getItem('searchTerm');
        document.querySelector('.collection-hero__description').textContent = "Sorry, we couldn’t find any results for your search, please try again.";
    }
});